/* eslint-disable no-nested-ternary */
import * as React from 'react';
import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import useFetch from '@hooks/useFetch';
import { calculateStreaks } from '@cont/MeDashboard/util';
import StreakItem from '@cont/MeDashboard/StreakItem';
import RoundedRectSkeleton from '@skeletons/RoundedRectSkeleton';
import { Spacings } from '@styles/index';

const StyP2 = styled(P2)`
  color: var(--color-text-secondary);
`;

const StyH5 = styled(H5)`
  color: ${(props) => props.color};
`;

const ProgressInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: ${Spacings.SPACING_3B};
`;

const DailyStreakWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Streak = styled.div<IPosition>`
  .StreamItemWrapper {
    padding-left: ${({ $position }) =>
      $position === 0 ? 0 : Spacings.SPACING_1B};
  }

  .LeftBg {
    z-index: 0;
    width: ${({ $position }) =>
      $position === 0 ? Spacings.SPACING_3B : Spacings.SPACING_4B};
  }

  .RightBg {
    z-index: 0;
    width: ${Spacings.SPACING_3B};
  }
`;

export interface IDailyStreaksProps {
  groupUID: string;
  userUID: string;
}

interface IPosition {
  $position: number;
}

const ProfilePopupContent: React.FC<IDailyStreaksProps> = ({
  groupUID,
  userUID
}) => {
  const {
    data: streaksInfo = {},
    isLoading,
    isError
  } = useFetch(
    `v2/group/member_details?user_uid=${userUID}&group_uid=${groupUID}`
  );

  const { dailyTasks = [] } = streaksInfo;
  let streaks = 0;
  let shouldBreak = false;
  const streaksData = [...dailyTasks];
  streaksData.reverse().forEach((task, index) => {
    if (task.isCompleted && !shouldBreak) {
      streaks += 1;
    } else if (index > 0) {
      shouldBreak = true;
    }
  });

  const streakString =
    isLoading || isError
      ? 'day'
      : streaks <= 1
      ? `${streaks} day`
      : `${streaks} days`;

  const [history, setHistory] = React.useState(null);

  React.useEffect(() => {
    if (dailyTasks) setHistory(calculateStreaks(dailyTasks));
  }, [dailyTasks]);

  const renderStreaksWeek = () => {
    if (!history || isLoading)
      return (
        // @ts-ignore
        <RoundedRectSkeleton height={24} width={214} />
      );

    return (
      <>
        {history.map((dailyTask, index) => {
          return (
            <Streak $position={index} key={dailyTask.date || index}>
              <StreakItem dailyTask={dailyTask} position={index} isGroups />
            </Streak>
          );
        })}
      </>
    );
  };

  return (
    <DailyStreakWrapper>
      <ProgressInfo>
        <StyH5 color="var(--color-i-orange-1)">{streakString}</StyH5>
        <StyP2>Streak</StyP2>
      </ProgressInfo>
      {renderStreaksWeek()}
    </DailyStreakWrapper>
  );
};

export default ProfilePopupContent;
